import controller from './my-garage.controller'
import template   from './my-garage.html'
import './my-garage.styl'

let component = {
  restrict: 'E',
  template,
  controller
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-garage/my-garage.component.js